import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { FontColorType } from '../helpers/font-styles';

export type IconStyleProps = {
  color?: FontColorType;
  size: number;
  noFill?: boolean;
};

export type IconThemeValues = {
  iconSize: string;
};

export type IconProps = {
  color?: FontColorType;
  size: number;
};

export const getIconTheme = ({ size }: Pick<IconProps, 'size'>) => ({
  iconSize: theme.fontSize(size),
});

export const icon: string = css`
  /* Keeps size consistent inside flex parents */
  transition: fill 200ms ease-out;
  user-select: none;
  line-height: 1;
`;

export const iconNoFill: string = css`
  fill: none;
`;

export const iconFill: string = css`
  fill: currentColor;
`;

export const IconStyles: { icon: string; iconNoFill: string; iconFill: string } = {
  icon,
  iconNoFill,
  iconFill,
};
